import { HTMLAttributes } from 'react';
import Image from 'next/image';
import { AvatarVariantType } from '../Types';
import styles from './Avatar.module.scss';
interface AvatarProps extends HTMLAttributes<HTMLDivElement> {
  alt: string;
  size: number;
  src?: string;
  variant?: AvatarVariantType;
  data_cy?: string;
  className?: string;
}
const Avatar = ({
  src,
  alt,
  size,
  variant = 'rounded',
  data_cy,
  className = '',
  ...props
}: AvatarProps) => {
  return <div {...props} className={`${styles['avatar']} ${styles[variant]} ${className} `} style={{
    width: size,
    height: size
  }} data-cy={data_cy} data-sentry-component="Avatar" data-sentry-source-file="Avatar.tsx">
      {src ? <Image src={src} alt={alt} width={size} height={size} className={styles['avatar-image']} /> : <span className={styles['avatar-placeholder']}>{alt.charAt(0)}</span>}
    </div>;
};
export default Avatar;